import type { ResponseType } from '@/types/IResponse'
import Api from '@/common/mods'
import type { ModStateType } from '@/store/interfaces/IMods'
import type { ModsType } from '@/types/IModsData'
import {PaginationType} from "@/types/IPaginationData";

export default {
    state: (): ModStateType => ({
        catalogMods: [],
        noveltyMods: [],
        popularMods: [],
        similarMods: [],
        pagination: null,
        preloaderShow: {
            catalog: true,
            popular: true,
            novelty: true,
            similar: true,
        },
    }),
    mutations: {
        updateCatalogMods(state: ModStateType, data: ModsType[]) {
            state.catalogMods = data
            if(data.length > 0) {
                state.preloaderShow.catalog = false
            }
        },
        updateSimilarMods(state: ModStateType, data: ModsType[]) {
          state.similarMods = data
          if(data.length > 0) {
              state.preloaderShow.similar = false
          }
        },
        updatePagination(state: ModStateType, data: PaginationType) {
            state.pagination = data
        },
        updateNoveltyMods(state: ModStateType, data: ModsType[]) {
            state.noveltyMods = data
            if(data.length > 0) {
                state.preloaderShow.novelty = false
            }
        },
        updatePopularMods(state: ModStateType, data: ModsType[]) {
            state.popularMods = data
            if(data.length > 0) {
                state.preloaderShow.popular = false
            }
        },
        disablePopularModsPreloader(state: ModStateType) {
            state.preloaderShow.popular = false
        },
        disableNoveltyModsPreloader(state: ModStateType) {
            state.preloaderShow.novelty = false
        },
        activatePreloaders(state: ModStateType) {
            state.preloaderShow.catalog = true
            state.preloaderShow.popular = true
            state.preloaderShow.novelty = true
            state.preloaderShow.similar = true
        },
    },
    actions: {
        uploadCatalogMods(ctx: any, sample: object) {
            ctx.commit('activatePreloaders')
            Api.getCatalogMods(sample, (res: any) => {
                ctx.commit('updateCatalogMods', res["data"]["mods"])
                ctx.commit('updatePagination', res["data"]["pagination"])
            })
        },
        uploadPopularMods(ctx: any, sample: object) {
            ctx.commit('activatePreloaders')
            Api.getPopularMods(sample, (res: ResponseType) => {
                ctx.commit('updatePopularMods', res["data"])
            })
        },
        uploadNoveltyMods(ctx: any, sample: object) {
            ctx.commit('activatePreloaders')
            Api.getNoveltyMods(sample, (res: ResponseType) => {
                ctx.commit('updateNoveltyMods', res["data"])
            })
        },
        uploadSimilarMods(ctx: any, sample: {game: string}) {
            ctx.commit('activatePreloaders')
            Api.getSimilarMods(sample, (res: ResponseType) => {
                ctx.commit('updateSimilarMods', res["data"])
            })
        }
    },
    getters: {
        getNoveltyMods(state: ModStateType) : ModsType[] {
            return state.noveltyMods
        },
        getCardsPreloaders(state: ModStateType) : object {
            return state.preloaderShow;
        },
        getPopularMods(state: ModStateType) : ModsType[] {
            return state.popularMods
        },
        getCatalogMods(state: ModStateType) : ModsType[] {
            return state.catalogMods
        },
        getPaginationData(state: ModStateType) : PaginationType | null {
            return state.pagination
        },
        getSimilarMods(state: ModStateType) : ModsType[] {
            return state.similarMods
        }
    }
}